import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';
import { postSse, SseEvent } from '@app/utils/sse-post';

@Injectable({ providedIn: 'root' })
export class AudioGenService {
  private apiUrl = `${environment.baseUrl}/audioGen`;

  constructor(private commonAPI: CommonApiService) {}

  listProjects(): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/listProjects`, { criteria: { tenant: null } });
  }

  createProject(data: {
    ProjectShortCode: string;
    ProjectName: string;
    CustomerShortCode: string;
  }): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/createProject`, {
      criteria: { ...data, tenant: null },
    });
  }

  uploadExcel(projectCode: string, fileName: string, fileBase64: string): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/uploadExcel`, {
      criteria: { projectCode, fileName, fileBase64, tenant: null },
    });
  }

  getLines(projectCode: string): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/getLines`, {
      criteria: { projectCode, tenant: null },
    });
  }

  generateWithProgress(
    projectCode: string,
    onEvent: (ev: SseEvent) => void,
  ): Promise<void> {
    return postSse(
      '/audioGen/generate',
      { projectCode, tenant: null },
      onEvent,
      { timeoutMs: 0 },
    );
  }

  downloadZip(projectCode: string): Observable<Blob> {
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/downloadZip`, {
      criteria: { projectCode, tenant: null },
    });
  }
}
